module.exports = "/_next/static/images/ourPartnersLogo12-02d6cda87dad8820575f4eeb67301cab.webp";